import { apiClient } from "rp-components"
import { ConfirmActionCodePayload } from "@/models/ActionCode"

export interface ActionCodeService {
    confirm(payload: ConfirmActionCodePayload): Promise<void>
}

class ActionCodeServiceImpl implements ActionCodeService {
    static instance?: ActionCodeService = undefined

    private constructor() {}

    static getInstance(): ActionCodeService {
        if (ActionCodeServiceImpl.instance == undefined) {
            ActionCodeServiceImpl.instance = new ActionCodeServiceImpl()
        }
        return ActionCodeServiceImpl.instance
    }

    async confirm(payload: ConfirmActionCodePayload): Promise<void> {
        await apiClient.post<void, ConfirmActionCodePayload>("/public/action-codes/confirm", payload)
    }
}

export default ActionCodeServiceImpl.getInstance()
